import { createAction } from '@reduxjs/toolkit';
export const getProjectById = createAction('@@projects/GET_PROJECT_BY_ID_SAGA');
export const updateProjectPhaseDatesAction = createAction('@@projects/updateProjectPhaseDates');
export const updateProjectSprintDatesAction = createAction('@@projects/updateProjectSprintDates');
export const updatePhaseDatesAction = createAction('@@projects/UPDATE_PHASE_DATES_SAGA');
export const addMembersToProject = createAction('@@projects/ADD_MEMBERS_TO_PROJECT_SAGA');
export const createAndInviteProjectMembersAction = createAction('@@projects/CREATE_AND_INVITE_PROJECT_MEMBERS');
export const removeMembersFromProject = createAction('@@projects/REMOVE_MEMBERS_FROM_PROJECT_SAGA');
export const updateProjectMembers = createAction('@@projects/UPDATE_PROJECT_MEMBERS_SAGA');
export const setGanttRefAction = createAction('@@projects/SET_GANTT_REF_SAGA');
export const updateGanttDatesAction = createAction('@@projects/UPDATE_GANTT_DATES_SAGA');
export const updateGanttSlackAction = createAction('@@projects/UPDATE_GANTT_SLACK_SAGA');
export const phaseDependencyCreated = createAction('@@projects/ON_PHASE_DEPENDENCY_CREATED');
export const updateTaskPrivacyInGanttAction = createAction('@@projects/UPDATE_TASK_PRIVACY_IN_GANTT_SAGA');
